import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 mb-4">
            <i className="ri-trophy-line text-primary-600 text-sm"></i>
            <span className="text-primary-700 text-xs font-medium">热度榜单</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            黑料热度榜
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            基于真实用户互动数据实时计算的热度排行
          </p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-50 border border-background-200/70 rounded-xl transition-all duration-200 hover:border-primary-200 hover:-translate-y-0.5 cursor-pointer"
            >
              {/* 排名 */}
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 font-heading font-black text-lg ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50 text-xl'
                  : item.rank === 2
                  ? 'bg-primary-400 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-300 text-background-50'
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {item.rank <= 3 ? (
                  <i className="ri-fire-fill text-base"></i>
                ) : (
                  item.rank
                )}
              </div>

              {/* 标题 */}
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
              </div>

              {/* 热度 */}
              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="text-right">
                  <div className="flex items-center gap-1 text-sm font-bold text-primary-500">
                    <i className="ri-fire-line"></i>
                    {item.heat}
                  </div>
                  <div className={`text-xs ${
                    item.trend === 'up' ? 'text-accent-500' : 'text-secondary-400'
                  }`}>
                    {item.change}
                  </div>
                </div>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center ${
                  item.trend === 'up' ? 'bg-accent-100' : 'bg-secondary-100'
                }`}>
                  {item.trend === 'up' ? (
                    <i className="ri-arrow-up-line text-accent-600 text-xs"></i>
                  ) : (
                    <i className="ri-arrow-down-line text-secondary-500 text-xs"></i>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}